module.exports = __webpack_public_path__ + "static/media/S1N11-3.325065d5.svg";